import { render } from "./BackButton.vue?vue&type=template&id=5ab9f9d1"
import script from "./BackButton.vue?vue&type=script&lang=ts"
export * from "./BackButton.vue?vue&type=script&lang=ts"
script.render = render

export default script